export default __webpack_public_path__ + "static/media/Ballroll_00233.7be4e8bb.png";